export default __webpack_public_path__ + "static/media/ChosainEntranceMap.4a45dae9.jpg";